import { query } from "@sinao/core-js";

const tags = {
	state: () => ({
		tags: []
	}),
	mutations: {
		tags(state, payload) {
			if (typeof payload === "string") {
				state.tags.push(payload);
			} else {
				/*
					Quand on import les tags d'un contact ils sont sous la forme ["tag 1", "tag 2"]
					Quand on ajout un tag par un input il est sous la forme {text: "tag", tiClasses:["ti-valid"]}
				*/
				state.tags = [];

				payload.map(tag => {
					if(typeof tag === "string")
						state.tags.push({text: tag, tiClasses:["ti-valid"]});
					else
						state.tags.push(tag);
				});
			}
		}
	},
	actions: {
		async getTags({ rootState }, appId) {
			const { page } = rootState;

			try {
				const response = await query({
					operationId: "app.statistics.tags.get",
					params: {
						appId,
						limit: 10,
						object: page.type === "invoices" ? "invoice" : "quote"
					}
				});

				// commit("tags", Object.values(response));

				return Object.values(response);
			} catch (error) {
				throw new Error(error);
			}
		}
	}
};

export default tags;
